// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__bAq8l","imageUploader":"EGiftCard_imageUploader__3qJgo"};